
<template>
  <div id="container">
    <Head :isShow="out"></Head>
    <div id="v-video-play">
      <!-- 视频主题部分 -->
      <div class="play-main">
        <div class="currhead">
          <h1 class="currh1">{{ courseName }}</h1>
          <div v-if="back" @click="goBack" class="currfont">
            返回
            <img
              alt
              src="@/assets/img/back.png"
              style="margin-left: 10px; height: 14px; width: 14px"
            />
          </div>
        </div>
        <div class="video-box">
          <div class="video-left">
            <!-- 阿里云播放器 -->
            <div
              :id="playerId"
              class="prism-player coincide"
              ref="player_con"
              v-if="Number(videoSourceType) === 1"
            ></div>
            <!-- 阔知网播放器 -->
            <div
              id="cloud-player"
              style="height: 100%; width: 100%"
              v-if="Number(videoSourceType) === 0"
            ></div>
            <div class="coverImg" v-if="isShowThumb">
              <!-- <img :src="goodsThumb" /> -->
              <img
                @click="playVideo"
                id="play_icon"
                src="@/assets/img/playicon.png"
              />
            </div>
          </div>
          <div class="video-right">
            <div class="tabs">
              <div
                :class="isIntruActive ? 'active' : ''"
                @click="switchTabs(1)"
                class="tab-item"
              >
                介绍
              </div>
              <div
                :class="isCageActive ? 'active' : ''"
                @click="switchTabs(2)"
                class="tab-item"
              >
                目录
              </div>
            </div>
            <div class="intru no-scroll-bar" v-show="isIntruActive">
              <div class="headinfo">{{ currentGoodsEntity.goodsName }}</div>
              <div class="description">{{ currentGoodsEntity.keywords }}</div>
            </div>
            <div
              class="cage no-scroll-bar"
              v-if="courseGoodsList && courseGoodsList.length > 0"
              v-show="isCageActive"
            >
              <div class="headinfo" v-if="catalogData.catalogName">
                {{ catalogData.catalogName }}
              </div>
              <div
                :class="[goodsId === item.goodsId ? 'active' : '']"
                :id="item.goodsId"
                :key="index"
                @click="PlayCourse(index)"
                class="cage-item"
                v-for="(item, index) in courseGoodsList"
              >
                <div class="title">
                  课时{{ index + 1 }}：{{ item.goodsName }}
                </div>
                <div class="detail">
                  <span
                    class="duration"
                    v-text="'时长：' + getDuration(item.catLength)"
                  ></span>
                  <span
                    class="playing"
                    v-if="goodsId === item.goodsId && isPlay === 0"
                    >播放中···</span
                  >
                  <span
                    class="playing"
                    v-if="goodsId === item.goodsId && isPlay === 1"
                    >暂停播放</span
                  >
                  <span
                    class="playing"
                    v-if="goodsId === item.goodsId && isPlay === 3"
                    >已结束</span
                  >
                  <span
                    class="playing"
                    v-if="goodsId === item.goodsId && isPlay === 4"
                    >待播放</span
                  >
                  <span
                    class
                    v-if="
                      item.courseGoodsLearnLogEntity != null &&
                      !(goodsId === item.goodsId) &&
                      item.courseGoodsLearnLogEntity.playTime < item.catLength
                    "
                    v-text="
                      '已学：' +
                      getDuration(item.courseGoodsLearnLogEntity.playTime)
                    "
                  ></span>
                  <span
                    class
                    v-if="
                      item.courseGoodsLearnLogEntity != null &&
                      !(goodsId === item.goodsId) &&
                      item.courseGoodsLearnLogEntity.playTime >= item.catLength
                    "
                    v-text="'已学完'"
                  ></span>
                </div>
              </div>
            </div>
            <div class="oper-btn" v-show="isCageActive">
              <div
                @click="preVideo"
                class="prev"
                v-if="!is_click_nextVideo && !is_click_preVideo"
              >
                上一节
              </div>
              <div
                class="prev"
                v-if="!(!is_click_nextVideo && !is_click_preVideo)"
              >
                上一节
              </div>
              <div
                @click="nextVideo"
                class="next"
                v-if="!is_click_nextVideo && !is_click_preVideo"
              >
                下一节
              </div>
              <div
                class="next"
                v-if="!(!is_click_nextVideo && !is_click_preVideo)"
              >
                下一节
              </div>
            </div>
          </div>
        </div>
        <div class="video-bottom" v-if="courseGoodsList.length > 0">
          <div class="text-left">
            <div class="viedo-desc">
              <div v-if="courseGoodsList[index].goodsName">
                小节名称：{{ courseGoodsList[index].goodsName }}
              </div>
              <!-- <div class="wrap" v-if="courseGoodsList[index].keywords">
                <div class="text">小节简介：{{courseGoodsList[index].keywords}}</div>
              </div>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Head from '@/components/pc/Head'
import * as COURSE_GOOD_API from '@/api/ChannelCourseAPI'
import * as CHANNEL_INFO_API from '@/api/ChannelAPI'
import * as COURSE_API from '@/api/ChannelCourseAPI'
import load from 'load-script'
export default {
  data () {
    return {
      logoUrl: localStorage.getItem('logoUrl') || sessionStorage.getItem('logoUrl'),
      goodsThumb: '',    //课程封面图片
      isPlay: '',         //播放器状态
      index: 0,           //当前播放视频索引
      progress: 0,        //提交数据的学习进度
      initProgresss: 0,   //数据库学习进度
      progressNow: 0,     //当前的实时学习进度
      keywords: '',       //页面显示的数据
      currentTime: 0,     //提交数据的学习时间(视频播放到的时间点)
      initCurrentTime: 0, //数据库学习时间
      currentTimeNow: 0,  //当前的实时学习时间
      timeOut: '',
      isAdd: false,        //是否提交学习进度
      courseId: '',       //当前播放的课程id
      catalogId: '',      //当前播放的章节id
      goodsId: '',        //当前播放的视频id
      resNo: '',          //阔知网视频编码
      player: '',         //播放器对象
      catLength: '',      //当前播放视频的时长
      playerId: 'aliplayer_' + Math.random().toString(36).substr(2),
      isShowThumb: true,  //封面是否显示
      videoSourceType: 0, //视频数据源，0-阔知网，1-阿里云
      waterMarkId: 0,    //水印id
      url: '',
      playTime: 0,        //播放器初始化播放时间点
      catalogData: {},    //当前目录章节的数据
      courseGoodsList: [],  //当前目录章节下的视频数据
      currentLearnGoodsId: 0, //最后一次学习的视频记录id
      currentGoodsEntity: {},
      videoToken: '',  //阔知网需要的播放token,服务端生成jwt加密算法
      courseName: '',
      name: '',
      contentTitle: '',
      contentText: '',
      coverImgUrl: '',
      courseList: [],
      imgUrl: '',
      currentTimes: 0,
      studyTime: 0,
      is_click: false,
      isImg: true,
      status: '',
      isIntruActive: true,
      isCageActive: false,
      findGoods: false,
      CatalogInfo: {},
      is_click_nextVideo: false,
      is_click_preVideo: false,
      isHeader: 0,
      isRecommend: null,
      back: true,
      out: localStorage.getItem('isHideOutButton') ==null ? true :false
    }
  },

  components: {
    Head
  },
  filters: {
    setText (val) {
      if (String(val).length >= 16) {
        return val.substring(0, 16) + '...'
      } else {
        return val
      }
    }
  },
  created () {
    //从课程详细 课时点击开始学习跳转此视频列表
    // 渠道商对接判断
    if (this.$route.query.gat_id && this.$route.query.token && this.$route.query.c_no && this.$route.query.cat_id ) {
      this.out=false
      localStorage.setItem('shangke_token', this.$route.query.token)
      console.log(this.$route.query.token,'wwwwwwww')
      localStorage.setItem('c_no', this.$route.query.c_no)
      this.courseId = this.$route.query.cat_id
      this.back=false
      this.goodsId = this.$route.query.gat_id
      this.getCourseInfo()
      this.ChannelFindInfo()
      sessionStorage.setItem('isChannel', 'true')
    }else if(this.$route.params.voidData) {
      this.goodsId = this.$route.params.goodsId
      this.courseName = this.$route.params.courseName
      this.catalogId = this.$route.params.courseGood.catalogId
      this.currentGoodsEntity = this.$route.params.courseGood
      this.isRecommend = this.$route.params.isRecommend
      this.getCatalogData()
    } else {
      this.goodsId = JSON.parse(sessionStorage.getItem('videoPlay')).goodsId
      this.courseName = JSON.parse(sessionStorage.getItem('videoPlay')).courseName
      this.catalogId = JSON.parse(sessionStorage.getItem('videoPlay')).courseGood.catalogId
      this.currentGoodsEntity = JSON.parse(sessionStorage.getItem('videoPlay')).courseGood
      this.isRecommend = JSON.parse(sessionStorage.getItem('videoPlay')).isRecommend
      this.getCatalogData()
    }


  },
  mounted () {
    if (!this.logoUrl) {
      CHANNEL_INFO_API.ChannelFindInfo(null).then(res => {
        this.channelName = res.data.channelName
        this.logoUrl = res.data.logoUrl
        localStorage.setItem('channelName', this.channelName)
        localStorage.setItem('logoUrl', this.logoUrl)
      })
    }
  },
  computed: {},
  destroyed () {
    this.AddLearnlod()
  },
  methods: {
    getCourseInfo () {
      let data = {
        courseId: this.courseId,
        tourist:  this.tourist
      }
      COURSE_API.GetCourseInfo(data)
        .then(res => {
          if (Number(res.code) === 0) {
            this.courseData = res.data
            if(this.courseData !=null ){
              if(this.courseData .isPay==null || this.courseData .isPay==0){
                this.isRecommend=true;
                this.$message.success('尚未购买此课程')
              }else if(this.courseData .isPay==1){
                this.isRecommend=false;
                this.goodsInfo()
              }

            }
          } else {
            console.log('err')
          }
        })
    },

    goodsInfo () {
        let data = {
        goodsId: this.goodsId,
        courseId: this.courseId
      }
      COURSE_GOOD_API.CourseGoodsDetail(data).then(res => {
        this.courseGood = res.data
   
        this.catalogId = this.courseGood.catalogId
        this.currentGoodsEntity = this.courseGood
        this.getCatalogData()
      })
    },
    ChannelFindInfo () {
      CHANNEL_INFO_API.ChannelFindInfo(null).then(res => {
        this.channelName = res.data.channelName
        this.logoUrl = res.data.logoUrl
        localStorage.setItem('channelName', this.channelName)
        localStorage.setItem('logoUrl', this.logoUrl)
        localStorage.setItem('isPopupChannelMsg', res.data.isPopupChannelMsg)
        localStorage.setItem('isHideOutButton', res.data.isPopupChannelMsg)
         if(res.data.isPopupChannelMsg!=null ||res.data.isPopupChannelMsg==1){
              this.back=false
          }
      })
    },


    //页面点击播放按钮
    playVideo () {
      this.isShowThumb = false
      if (this.videoSourceType == 1) {
        this.player.play()
      }

    },
    initPlayer () {
      if (Number(this.videoSourceType) === 0) {
        //初始化阔知网视频播放器
        this.resNo = this.currentGoodsEntity.kzwVideoNo
        this.isHeader = this.currentGoodsEntity.isHeader
        this.waterMarkId = this.currentGoodsEntity.waterMarkId
        //阔知网初始化播放器
        this.getVideoToken(this.resNo)
      } else {
        //初始化阿里云播放器
        let url = this.currentGoodsEntity.goodsVideo
        setTimeout(() => {
          this.aliPlayer(url)
        }, 500)
      }
    },

    //回退
    goBack () {
      if (this.player && this.player.dispose) {
        this.player.dispose()
      }
      if (this.player && this.player.destory) {
        this.player.destory()
      }
      this.$router.back()
    },

    // 查询当前章节信息
    getCatalogData () {

      // 获取该课程信息
      let data = {
        catalogId: this.catalogId,
        tourist:  this.isRecommend
      }
      // 获取menu数据
      COURSE_GOOD_API.catalogInfo(data)
        .then(res => {
          if (Number(res.code) === 0) {
            this.catalogData = res.data
            this.getCourseGoodsList()
          } else if (res.code === 401) {
            this.$message.error('登录失效，请重新登录')
            this.$router.push({
              name: 'login'
            })
          } else {
            this.catalogData = {}
            this.courseGoodsList = []
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    getCourseGoodsList () {
      // 获取该课程信息
      let data = {
        courseId: this.courseId,
        catalogId: this.catalogId,
        tourist: this.isRecommend
      }
      // 获取menu数据
      COURSE_GOOD_API.getCourseGoodsList(data)
        .then(res => {
          if (Number(res.code) === 0) {
            this.courseGoodsList = res.data
            if (res.data && this.courseGoodsList.length > 0) {
              for (let i = 0; i < this.courseGoodsList.length; i++) {
                const goodsEntity = this.courseGoodsList[i];
                if (goodsEntity.goodsId == this.goodsId) {
                  this.index = i;
                  if (!goodsEntity.kzwVideoNo) {
                    this.videoSourceType = 1
                  }
                  break
                }
                console.log('---------')
                console.log(this.videoSourceType)
              }
              this.PlayCourse(this.index)
            }
          } else if (res.code === 401) {
            this.$message.error('登录失效，请重新登录')
            this.$router.push({
              name: 'login'
            })
          } else {
            this.courseGoodsList = []
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 点击事件加载视频获取视频资源
    PlayCourse (index) {
      console.log('点击事件加载视频获取视频资源01')
      this.beforeDestroy()
      if (this.is_click) {
        return false;
      }
      this.is_click = true;
      setTimeout(() => {
        this.is_click = false;
      }, 1000);
      if (!this.isShowThumb) {
        this.isShowThumb = true
      }
      if (this.player) {
        if (Number(this.videoSourceType) === 0) {
          this.player.destory()
        } else {
          this.player.dispose()
          clearInterval(this.timeOut)
        }
        this.isPlay = 4
      }
      this.index = index
      this.playTime = 0
      this.currentGoodsEntity = this.courseGoodsList[this.index]
      if (this.currentGoodsEntity.courseGoodsLearnLogEntity) {
        this.playTime = this.currentGoodsEntity.courseGoodsLearnLogEntity.playTime
        this.initCurrentTime = this.currentGoodsEntity.courseGoodsLearnLogEntity.playTime
        this.initProgresss = this.currentGoodsEntity.courseGoodsLearnLogEntity.progress
      }

      this.goodsId = this.currentGoodsEntity.goodsId
      this.catalogId = this.currentGoodsEntity.catalogId
      this.courseId = this.currentGoodsEntity.courseId
      this.goodsThumb = this.courseGoodsList[this.index].goodsThumb
      this.catLength = this.courseGoodsList[this.index].catLength
      this.initPlayer();
    },
    // 添加学习记录

    AddLearnlod () {
      if (!this.isRecommend) {
        if ((this.currentGoodsEntity.courseGoodsLearnLogEntity == null || this.progress > this.currentGoodsEntity.courseGoodsLearnLogEntity.progress) && this.currentTime > 0 && this.progress > 0) {
          console.log('添加学习记录55')
          let data = {
            goodsId: this.goodsId,
            courseId: this.courseId,
            catalogId: this.catalogId,
            progress: this.progress,
            playTime: this.currentTime,
            channelNo: localStorage.getItem('c_no'),
          }
          if (this.isAdd) {
            COURSE_GOOD_API.AddLearnlod(data)
              .then(res => {
                if (res) {
                  this.isAdd = false
                  console.log('添加成功')
                  if (this.courseGoodsList.length > 0) {
                    for (let i = 0; i < this.courseGoodsList.length; i++) {
                      if (data.goodsId == this.courseGoodsList[i].goodsId) {
                        this.courseGoodsList[i].courseGoodsLearnLogEntity = data
                      }
                    }
                  }
                }
              }).catch(err => {
                console.log(err)
              })
          }
        }
      }

    },
    //时间转换
    getDuration (second) {
      var duration
      var days = Math.floor(second / 86400);
      var hours = Math.floor((second % 86400) / 3600);
      var minutes = Math.floor(((second % 86400) % 3600) / 60);
      var seconds = Math.floor(((second % 86400) % 3600) % 60);
      if (days > 0)
        duration = days + "天" + hours + "小时" + minutes + "分" + seconds + "秒";
      else if (hours > 0)
        duration = hours + "小时" + minutes + "分" + seconds + "秒";
      else if (minutes > 0)
        duration = minutes + "分" + seconds + "秒";
      else if (seconds > 0)
        duration = seconds + "秒";
      return duration

    },

    switchTabs ($item) {
      if ($item === 1) {
        this.isIntruActive = true
        this.isCageActive = false
      } else if ($item === 2) {
        this.isCageActive = true
        this.isIntruActive = false
      }
    },

    getVideoToken (kzwVideoNo) {
      // 获取该课程信息
      let data = {
        nos: kzwVideoNo,
        skipHead: 1,
        tourist: this.tourist
      }
      // 获取menu数据
      COURSE_GOOD_API.videoToken(data)
        .then(res => {
          if (Number(res.code) === 0) {
            this.videoToken = res.data[0].videoToken
            setTimeout(() => {
              this.videoPlay(this.videoToken)
            }, 500)
          } else {
            this.catalogData = {}
            this.courseGoodsList = []
            this.$message.error('获取播放授权失败')
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 初始化阔知网视频播放器
    videoPlay (token) {
      let that = this
      // 测试 service-cdn.cg-dev.cn
      // service-cdn.qiqiuyun.net
      load(
        '//service-cdn.qiqiuyun.net/js-sdk-v2/sdk-v1.js?' +
        ~~(Date.now() / 1000 / 60),
        err => {
          if (err) {
            throw err
          }
          /* eslint-disable no-new */
          that.player = new window.QiQiuYun.Player({
            id: 'cloud-player',
            // 用于初始化的DOM节点ID
            resNo: that.resNo,
            // 播放资源编号
            token: token,
            // 设置是否跳转至上次观看位置继续
            rememberLastPos: true,
            playbackRates: [0.5, 1, 1.5, 2.0],
            // 封面图
            // poster: that.goodsThumb,
            initPos: that.playTime,
            skip: that.isHeader,
            // 播放令牌由后端SDK生成
            // playServer: 'play.qiqiuyun.net',
            // 关于水印的相关参数
            watermark: {
              file: that.logoUrl,
              pos: 'top.right',
              width: '80px'
            }
          })
            .on('timeupdate', function (event) {
              console.log(event, '我在播放')
              var totalTime = event.duration
              var currentTime = event.currentTime
              var progress = 0
              currentTime = parseInt(currentTime)
              progress = (currentTime / totalTime).toFixed(2)
              that.currentTime = currentTime
              that.progress = progress
              that.isPlay = 0
              that.isAdd = true
            })
            .on('ready', function (event) {
              console.log(event, '我在准备中')
              that.isPlay = 4
            })
            .on('paused', function (event) {
              console.log(event, '我暂停播放')
              that.isPlay = 1
              that.AddLearnlod()
            })
            .on('ended', function (event) {
              console.log(event, '我播放结束')
              that.isPlay = 3
              that.AddLearnlod()
            })
        }
      )
    },

    //初始化阿里云播放器
    aliPlayer (url) {
      var that = this
      // 阿里播放器
      /* eslint-disable */
      that.player = new Aliplayer(
        {
          id: that.playerId,
          /* 指定多路清晰度流的地址的地址 */
          source: url,
          playsinline: true, // H5是否内置播放
          useH5Prism: true, // 强制H5播放器
          width: '100%',
          // cover: that.goodsThumb,
          height: '100%',
          autoplay: false,
          isLive: false
        },
        function (player) {
          that.timeOut = setInterval(() => {
            var totalTime = player.getDuration()
            var currentTimeTemp = player.getCurrentTime()
            var progressTemp = 0
            currentTimeTemp = parseInt(currentTimeTemp)
            progressTemp = (currentTimeTemp / totalTime).toFixed(2)
            that.currentTimeNow = currentTimeTemp
            that.progressNow = progressTemp
            if (player.getStatus() === 'pause') {
              that.isPlay = 1
              if (currentTimeTemp > that.initCurrentTime && progressTemp > that.initProgresss) {
                that.currentTime = currentTimeTemp
                that.progress = progressTemp
                that.initCurrentTime = currentTimeTemp
                that.initProgresss = progressTemp
                that.isAdd = true
                that.AddLearnlod()
              }
            } else if (player.getStatus() === 'ended') {
              that.isPlay = 3
              if (currentTimeTemp > that.currentTime && progressTemp > that.progress) {
                that.currentTime = currentTimeTemp
                that.progress = progressTemp
                that.isAdd = true
                that.AddLearnlod()
                clearInterval(that.timeOut)
                that.progress = 0
                that.currentTime = 0
              }
            } else if (
              player.getStatus() === 'ready' ||
              player.getStatus() === 'loading' ||
              player.getStatus() === 'init'
            ) {
              that.isPlay = 4
            } else {
              that.currentTime = currentTimeTemp
              that.progress = progressTemp
              that.isPlay = 0
              that.isAdd = true
            }
            /* eslint-disable */
            if (that.player._el == null) {
              clearInterval(that.timeOut)
              that.progress = 0
              that.currentTime = 0
            }
            /* eslint-enable */
          }, 1000)
        }
      )
      setTimeout(() => {
        if (that.progress < 98) {
          that.player.seek(that.playTime)
        }
      }, 2500)
    },
    // 上一章视频
    preVideo () {
      if (this.is_click_preVideo) {
        return false;
      }
      this.is_click_preVideo = true;
      setTimeout(() => {
        this.is_click_preVideo = false;
      }, 1000);
      if (this.index > 0) {
        this.isPlay === 4

        this.index = this.index - 1
        this.PlayCourse(this.index)
      } else {
        this.$message.warning('没有上一章视频了')
      }
    },
    // 下一章视频
    nextVideo () {
      if (this.is_click_nextVideo) {
        return false;
      }
      this.is_click_nextVideo = true;
      setTimeout(() => {
        this.is_click_nextVideo = false;
      }, 1000);
      if (this.index < this.courseGoodsList.length - 1) {
        this.isPlay === 4

        this.index = this.index + 1
        this.PlayCourse(this.index)
      } else {
        this.$message.warning('没有下一章视频了')
      }
    },

    beforeDestroy () {
      this.AddLearnlod()
      this.currentTime = this.currentTimeNow
      this.progress = this.progressNow || 0
      if (isNaN(this.progress)) {
        this.progress = (this.currentTime / this.catLength).toFixed(2)
      }
      clearInterval(this.timeOut)
      this.currentTime = 0
      this.progress = 0
    },
  }

}
</script>

<style lang="less" scoped>
.tabs {
  width: 100%;
  border-bottom: 1px solid #2e303d;
  .tab-item {
    display: inline-block;
    width: 50%;
    text-align: center;
    line-height: 40px;
    &.active {
      background: #1f202c;
      color: #47a2ff;
    }
  }
}
.intru {
  height: 100%;
  overflow: auto;
}
.headinfo {
  line-height: 48px;
  border-bottom: 1px solid #2e303d;
  font-size: 18px;
  padding: 0 20px;
}
.description {
  padding: 20px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 28px;
}

.cage {
  height: 100%;
  overflow: auto;
  padding-bottom: 108px;
}
.cage-item {
  padding: 15px 20px;
  border-bottom: 1px solid #2e303d;
  &.learned {
    opacity: 0.3;
  }
  &.active {
    background: #1f202c;
  }
  &:hover {
    background: #1f202c;
  }
  .title {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    line-height: 28px;
  }
  .playing {
    color: #ffc64c;
  }
}
.oper-btn {
  position: absolute;
  bottom: 0;
  width: 100%;
  background: #15161e;
  height: 68px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .prev,
  .next {
    width: 140px;
    height: 36px;
    background: rgba(31, 32, 44, 1);
    border-radius: 4px;
    text-align: center;
    line-height: 36px;
    color: #ffffff;
    text-overflow: ellipsis;
    overflow: hidden;
    &:hover {
      color: #47a2ff;
    }
  }
}
.detail {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(197, 197, 198, 1);
  line-height: 28px;
  display: flex;
  justify-content: space-between;
}
.currhead {
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.currh1 {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #ffffff;
  line-height: 64px;
}
.currfont {
  font-size: 16px;
  color: #ffffff;
  line-height: 64px;
}
#v-video-play {
  width: 100%;
  background-color: #282a39;
  height: 59.375rem;
  position: absolute;
  left: 0;
  z-index: 2;
  .play-main {
    max-width: 1282px;
    margin: 0 auto;
    .video-box {
      width: 100%;
      height: 34rem;
      display: flex;
      .video-left {
        width: 75%;
        position: relative;
        .video-details-video {
          background-color: #010101;
        }
        .coverImg {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          z-index: 1000;
          img {
            width: 100%;
            height: 100%;
          }
          #play_icon {
            display: inline-block;
            background-size: cover;
            position: absolute;
            width: 3.75rem;
            height: 3.75rem;
            cursor: pointer;
            left: 50%;
            top: 50%;
            z-index: 1005;
            transform: translate(-50%, -50%);
          }
        }
      }
      .video-right {
        width: 25%;
        background-color: #15161e;
        height: 100%;
        overflow: hidden;
        position: relative;
        color: #ffffff;
        .video-top {
          height: 5.5rem;
          width: 100%;
          padding: 1rem 1.4rem;
          border-bottom: 1px solid #4a4d60;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          color: #fff;
          div {
            font-size: 1.0625rem;
          }
          div:last-child {
            color: #e2e2e2;
            font-size: 0.875rem;
            span:first-child {
              margin-right: 1.5rem;
            }
          }
        }
        .video-body {
          height: 39rem;
          overflow-y: auto;
          .video-list {
            .video-li {
              padding: 1rem 1.4rem;
              border-bottom: 1px solid #4a4d60;
              cursor: pointer;
              div {
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-size: 0.875rem;
                color: #fff;
              }
              div:first-child {
                span:first-child {
                  width: 80%;
                }
                span:last-child {
                  width: 15%;
                }
              }
              div:last-child {
                margin-top: 0.35rem;
                font-size: 0.75rem;
                color: #c5c5c6;
                span:last-child {
                  color: #ffc64c;
                }
              }
            }
            .video-li-active {
              background-color: #4a4d60;
            }
          }
        }
        .video-body::-webkit-scrollbar {
          width: 5px;
        }
        .video-body::-webkit-scrollbar-track {
          background-color: #4f5268;
        }
        .video-body::-webkit-scrollbar-thumb {
          background-color: #36abff;
        }
      }
    }
    .video-bottom {
      margin-top: 10px;
      width: 100%;
      display: flex;
      justify-content: space-between;
      color: #fff;
      .text-left {
        display: flex;
        width: 77.5%;
        justify-content: space-between;
        .viedo-desc {
          width: 60%;
          display: inline-flex;
          flex-direction: column;
          justify-content: space-between;
          div {
            line-height: 1.3rem;
          }
          .wrap {
            height: 5.02rem;
            line-height: 1.3rem;
            overflow: hidden;
            &::before {
              float: left;
              width: 5px;
              content: '';
              height: 90px;
            }
            &::after {
              float: right;
              content: '...';
              height: 1.4rem;
              line-height: 1.3rem;
              /* 为三个省略号的宽度 */
              width: 3em;
              /* 使盒子不占位置 */
              margin-left: -3em;
              /* 移动省略号位置 */
              position: relative;
              left: 99.5%;
              top: -2rem;
              padding-right: 5px;
              background-color: #282a39;
            }
            .text {
              float: right;
              margin-left: -5px;
              width: 100%;
              word-break: break-all;
            }
          }
        }
        .viedo-btn {
          width: 20%;
          display: flex;
          justify-content: flex-end;
          .btn-style {
            display: inline-flex;
            width: 13.75rem;
            height: 3.875rem;
            justify-content: space-between;
            flex-direction: column;
            align-items: center;
            background-color: #36abff;
            padding: 0.5625rem 1.5rem;
            div {
              font-size: 0.75rem;
            }
            div:first-child {
              font-weight: bold;
              font-size: 1.125rem;
            }
          }
        }
      }
      .text-right {
        width: 22.5%;
        display: flex;
        justify-content: space-around;
        span {
          display: inline-flex;
          width: 30%;
          height: 2.2rem;
          justify-content: center;
          align-items: center;
          border-radius: 5px;
          color: #fff;
          border: 1px solid #fff;
          cursor: pointer;
          &:hover {
            background-color: #36abff;
          }
        }
      }
    }
  }
}
</style>
